interface HeroProps {
  onQuoteClick: () => void;
  onConsultClick: () => void;
}

export default function Hero({ onQuoteClick, onConsultClick }: HeroProps) {
  return (
    <div className="relative bg-gradient-to-br from-blue-50 via-white to-blue-50 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-300 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-6 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white px-6 py-3 rounded-full text-base font-bold mb-8 shadow-lg">
              <img 
                src="https://www.inforesta.com/lp/image/6219bf22566b2c48557716b7afdebdfb.jpeg" 
                alt="インフォレスタロゴ" 
                className="w-8 h-8 rounded-full object-cover"
              />
              <span>医学論文ならインフォレスタ</span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              国内・海外の医学論文が<br />
              <span className="text-blue-600">最短15分で手に入ります。</span>
            </h1>
            
            <p className="text-xl text-gray-600 mb-4">
              1分で無料見積。URLを貼るだけでOK。
            </p>
            <p className="text-lg text-gray-500 mb-12">
              医師・製薬企業・研究者・医薬代理店・医療従事者の方に選ばれる専門サービス
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-16">
              <button 
                onClick={onQuoteClick}
                className="group bg-blue-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-file-list-3-line"></i>
                無料見積もりを依頼する
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </button>
              <button 
                onClick={onConsultClick}
                className="bg-white text-blue-600 px-8 py-4 rounded-xl font-bold text-lg border-2 border-blue-600 hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-chat-3-line"></i>
                お問い合わせはこちら
              </button>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="flex flex-col items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-3">
                  <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                </div>
                <p className="font-bold text-gray-900 text-sm">著作権コンプライアンスに精通</p>
              </div>
              <div className="flex flex-col items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-3">
                  <i className="ri-global-line text-2xl text-blue-600"></i>
                </div>
                <p className="font-bold text-gray-900 text-sm">国内・海外雑誌対応</p>
              </div>
              <div className="flex flex-col items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mb-3">
                  <i className="ri-user-star-line text-2xl text-blue-600"></i>
                </div>
                <p className="font-bold text-gray-900 text-sm">第三者提供用にも対応</p>
              </div>
            </div>
          </div>
          
          <div className="relative lg:block hidden">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://www.inforesta.com/lp/image/e31cd9d49843b7f9d08ce80da81e4967.jpeg"
                alt="医学論文研究イメージ"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-blue-500 rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-blue-400 rounded-full opacity-20 blur-2xl"></div>
          </div>
        </div>
      </div>
    </div>
  );
}